import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const formValidatorStoreSlice = createSlice({
  name: "formValidatorStore",
  initialState: {},
  reducers: {
    setFormvalidatorStore: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setFormvalidatorStore } = formValidatorStoreSlice.actions;

export const formValidatorStore = formValidatorStoreSlice.reducer;

export default formValidatorStoreSlice.reducer;
